import React from 'react';
import { useLocation } from 'react-router-dom';
import { Observer } from 'mobx-react';
import { FlexDiv, WideBox } from '../../styles/styles';
import ContactForm from '../ContactForm';

// const schema = yup.object().shape({
//   address1: yup.string().required(),
//   address2: yup.string(),
//   city: yup.string(),
//   email: yup.string().email().required,
//   firstName: yup.string(),
//   lastName: yup.string(),
//   name: yup.string().required,
//   phone: yup.string(),
//   state: yup.string(),
//   zip: yup.string(),
// });

const NewContact = () => {
  return (
    <Observer
      render={() => {
        const location = useLocation();
        const { state } = location;

        return (
          <FlexDiv>
            <WideBox style={{ justifyContent: 'center' }}>
              <ContactForm
                contactAgent={state ? state.fromContactAgent : null}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default NewContact;
